'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'brush';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'f55d';
var svgPathData = ['M32 64l0 192 320 0 0-192c0-17.7-14.3-32-32-32l-96 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112-32 0C46.3 32 32 46.3 32 64zm0 224l0 16c0 26.5 21.5 48 48 48l48 0c17.7 0 32 14.3 32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-17.7 14.3-32 32-32l48 0c26.5 0 48-21.5 48-48l0-16-320 0z', 'M256 352c-17.7 0-32 14.3-32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7-14.3-32-32-32l-48 0c-26.5 0-48-21.5-48-48l0-16 320 0 0 16c0 26.5-21.5 48-48 48l-48 0zm96-96L32 256 32 64c0-17.7 14.3-32 32-32l32 0 0 112c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112 64 0 0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80 96 0c17.7 0 32 14.3 32 32l0 192zM80 384l48 0 0 64c0 35.3 28.7 64 64 64s64-28.7 64-64l0-64 48 0c44.2 0 80-35.8 80-80l0-240c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 304c0 44.2 35.8 80 80 80z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBrush = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;